import { createTheme } from '@mui/material/styles';
import { COLORS, FONTS, SPACING, FIELD_WIDTHS } from './themeConstants';

export const theme = createTheme({
  palette: {
    primary: {
      main: COLORS.primary.main,
      light: COLORS.primary.light,
      dark: COLORS.primary.dark,
    },
    secondary: {
      main: COLORS.secondary.main,
      light: COLORS.secondary.light,
      dark: COLORS.secondary.dark,
    },
    text: {
      primary: COLORS.text.primary,
      secondary: COLORS.text.secondary,
    },
    background: {
      default: COLORS.background.default,
      paper: COLORS.background.paper,
    },
    error: {
      main: COLORS.error.main,
      light: COLORS.error.light,
      dark: COLORS.error.dark,
    },
    success: {
      main: COLORS.success.main,
      light: COLORS.success.light,
      dark: COLORS.success.dark,
    },
    warning: {
      main: COLORS.warning.main,
      light: COLORS.warning.light,
      dark: COLORS.warning.dark,
    },
    info: {
      main: COLORS.info.main,
      light: COLORS.info.light,
      dark: COLORS.info.dark,
    },
  },
  typography: {
    fontFamily: FONTS.family.primary,
    fontSize: parseInt(FONTS.size.sm),
    h1: {
      fontSize: FONTS.size.xxl,
      fontWeight: FONTS.weight.bold,
    },
    h2: {
      fontSize: FONTS.size.xl,
      fontWeight: FONTS.weight.bold,
    },
    h3: {
      fontSize: FONTS.size.lg,
      fontWeight: FONTS.weight.bold,
    },
    body1: {
      fontSize: FONTS.size.md,
      fontWeight: FONTS.weight.regular,
    },
    body2: {
      fontSize: FONTS.size.sm,
      fontWeight: FONTS.weight.regular,
    },
    caption: {
      fontSize: FONTS.size.xs,
      fontWeight: FONTS.weight.regular,
    },
  },
  components: {
    MuiRadio: {
      defaultProps: {
        color: 'secondary',
      },
      styleOverrides: {
        root: {
          color: COLORS.secondary.main,
    
          '&.Mui-checked': {
            color: COLORS.secondary.main,
          },
    
          // 👇 THIS is the missing part
          '& .MuiSvgIcon-root': {
            color: COLORS.secondary.main,
          },
    
          '&.Mui-checked .MuiSvgIcon-root': {
            color: COLORS.secondary.main,
          },
        },
      },
    },
    
    MuiFormControl: {
      styleOverrides: {
        root: {
          marginBottom: SPACING.sm,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-start',
          '& .MuiInputLabel-root': {
            position: 'relative',
            transform: 'none',
            width: '130px',
            color: COLORS.text.label,
            fontSize: FONTS.size.sm,
            marginRight: SPACING.xs,
            textAlign: 'right',
            paddingTop: SPACING.sm,
            fontWeight: FONTS.weight.medium,
          },
          '& .MuiFormLabel-root': {
            width: '130px',
            color: COLORS.text.label,
            fontSize: FONTS.size.sm,
            marginRight: SPACING.xs,
            textAlign: 'right',
            paddingTop: SPACING.sm,
            fontWeight: FONTS.weight.medium,
          },
          '& .MuiOutlinedInput-root': {
            height: '32px',
          },
          '& .MuiSelect-select': {
            padding: `${SPACING.xs} ${SPACING.sm}`,
            minHeight: '20px',
            display: 'flex',
            alignItems: 'center',
          },
          '& .MuiFormHelperText-root': {
            position: 'absolute',
            bottom: '-20px',
            //marginLeft: '134px',
            fontSize: FONTS.size.xs,
          },
          '& .MuiRadioGroup-root': {
            flexDirection: 'row',
            gap: SPACING.md,
            marginLeft: SPACING.xs,
          },
          '& .MuiFormGroup-root': {
            flexDirection: 'row',
            gap: SPACING.md,
            marginLeft: SPACING.xs,
          },
          '& .MuiFormControlLabel-root': {
            margin: 0,
            '& .MuiRadio-root': {
              padding: SPACING.xs,
            },
            '& .MuiCheckbox-root': {
              padding: SPACING.xs,
            },
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: COLORS.background.paper,
          width: FIELD_WIDTHS.lg,
          '& input': {
            padding: `${SPACING.xs} ${SPACING.sm}`,
            height: '20px',
            '&::placeholder': {
              color: 'rgba(0, 0, 0, 0.38)',
              opacity: 1,
            },
          },
          '&.input-large': {
            width: FIELD_WIDTHS.lg,
          },
        },
      },
      variants: [
        {
          props: { size: 'small' },
          style: {
            width: FIELD_WIDTHS.xs,
          },
        },
        {
          props: { size: 'medium' },
          style: {
            width: FIELD_WIDTHS.md,
          },
        },
      ],
    },
    MuiInputLabel: {
      styleOverrides: {
        asterisk: {
          color: COLORS.error.main,
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          backgroundColor: COLORS.background.paper,
          minHeight: '20px',
          display: 'flex',
          alignItems: 'center',
          padding: '4px 8px',
          '&.MuiSelect-select': {
            '&[value=""]': {
              color: COLORS.text.placeholder,
            },
          },
          '& .MuiSelect-select': {
            '&[value=""]': {
              color: COLORS.text.placeholder,
            },
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          minHeight: '32px',
          fontSize: FONTS.size.sm,
        },
      },
    },
  },
});
